import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
/**
 * Query parameters the audit trail endpoints accept.
 *
 * Every audited resource is read the same way — what changed, who changed it and when — so the
 * record being audited comes from the path and this describes the rest.
 */
export const FlowAuditQuerySchema = z.object({
    fieldNames: z
        .union([z.array(z.string()), z.string()])
        .describe('Return only changes to this field, or to any of these fields.')
        .optional(),
    userId: z.string().describe('Return only changes made by this user.').optional(),
    userEmail: z.string().describe('Return only changes made by this user.').optional(),
    createdBefore: z.coerce.date().describe('Return only changes made before this time.').optional(),
    createdAfter: z.coerce.date().describe('Return only changes made after this time.').optional(),
    limit: FlowApiPageLimitSchema.describe('How many changes to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as created.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
});
//# sourceMappingURL=audit.js.map